/**
 * Available navigation apps for iOS
 */
export var IOSNavigationApp;
(function (IOSNavigationApp) {
    IOSNavigationApp["APPLE_MAPS"] = "apple_maps";
    IOSNavigationApp["GOOGLE_MAPS"] = "google_maps";
    IOSNavigationApp["WAZE"] = "waze";
    IOSNavigationApp["CITYMAPPER"] = "citymapper";
    IOSNavigationApp["GARMIN_NAVIGON"] = "garmin_navigon";
    IOSNavigationApp["TRANSIT_APP"] = "transit_app";
    IOSNavigationApp["YANDEX_NAVIGATOR"] = "yandex";
    IOSNavigationApp["UBER"] = "uber";
    IOSNavigationApp["TOMTOM"] = "tomtom";
    IOSNavigationApp["SYGIC"] = "sygic";
    IOSNavigationApp["HERE_MAPS"] = "here";
    IOSNavigationApp["MOOVIT"] = "moovit";
    IOSNavigationApp["LYFT"] = "lyft";
    IOSNavigationApp["MAPS_ME"] = "mapsme";
    IOSNavigationApp["CABIFY"] = "cabify";
    IOSNavigationApp["BAIDU"] = "baidu";
    IOSNavigationApp["GAODE"] = "gaode";
    IOSNavigationApp["TAXI_99"] = "99taxi";
})(IOSNavigationApp || (IOSNavigationApp = {}));
/**
 * Available navigation apps for Android
 */
export var AndroidNavigationApp;
(function (AndroidNavigationApp) {
    AndroidNavigationApp["GOOGLE_MAPS"] = "google_maps";
    AndroidNavigationApp["WAZE"] = "waze";
    AndroidNavigationApp["CITYMAPPER"] = "citymapper";
    AndroidNavigationApp["UBER"] = "uber";
    AndroidNavigationApp["YANDEX"] = "yandex";
    AndroidNavigationApp["SYGIC"] = "sygic";
    AndroidNavigationApp["HERE_MAPS"] = "here";
    AndroidNavigationApp["MOOVIT"] = "moovit";
    AndroidNavigationApp["LYFT"] = "lyft";
    AndroidNavigationApp["MAPS_ME"] = "mapsme";
    AndroidNavigationApp["CABIFY"] = "cabify";
    AndroidNavigationApp["BAIDU"] = "baidu";
    AndroidNavigationApp["GAODE"] = "gaode";
})(AndroidNavigationApp || (AndroidNavigationApp = {}));
/**
 * Transport modes
 */
export var TransportMode;
(function (TransportMode) {
    TransportMode["DRIVING"] = "driving";
    TransportMode["WALKING"] = "walking";
    TransportMode["BICYCLING"] = "bicycling";
    TransportMode["TRANSIT"] = "transit";
})(TransportMode || (TransportMode = {}));
/**
 * Launch modes
 */
export var LaunchMode;
(function (LaunchMode) {
    LaunchMode["MAPS"] = "maps";
    LaunchMode["TURN_BY_TURN"] = "turn_by_turn";
    LaunchMode["GEO"] = "geo";
})(LaunchMode || (LaunchMode = {}));
//# sourceMappingURL=definitions.js.map